import { call, put, takeLatest } from "redux-saga/effects";
import {
  addStaffFailure,
  addStaffSuccess,
  deleteStaffFailure,
  deleteStaffSuccess,
  fetchHistoryStaffFailure,
  fetchHistoryStaffSuccess,
  fetchStaffFailure,
  fetchStaffMemberFailure,
  fetchStaffMemberSuccess,
  fetchStaffSuccess,
  updateStaffFailure,
  updateStaffSuccess
} from "./staffAction";
import {
  addStaffEffect,
  deleteStaffEffect,
  editStaffEffect,
  historyStaffEffect,
  listStaffEffect,
  ViewStaffEffect,
} from "./staffEffect";
import {
  ADD_STAFF_REQUEST,
  DELETE_STAFF_REQUEST,
  FETCH_LIST_STAFF_REQUEST,
  FETCH_STAFF_REQUEST,
  HISTORY_STAFF_REQUEST,
  UPDATE_STAFF_REQUEST
} from "./staffType";

function* fetchStaffsSaga(action) {
  
  try {
    const staffs = yield call(listStaffEffect, action.payload);
    yield put(fetchStaffSuccess(staffs));
  } catch (error) {
    yield put(fetchStaffFailure(error.message));
  }
}
function* fetchGHistoryStaffsSaga(action) {
  try {
    const staffs = yield call(historyStaffEffect, action.payload);
    yield put(fetchHistoryStaffSuccess(staffs));
  } catch (error) {
    yield put(fetchHistoryStaffFailure(error.message));
  }
}
function* fetchStaffSaga(action) {
  try {
    const staff = yield call(ViewStaffEffect, action.payload.staffId);
    
    yield put(fetchStaffMemberSuccess(staff));
  } catch (error) {
    yield put(fetchStaffMemberFailure(error.message));
  }
}

function* addStaffSaga(action) {
  try {
      const response = yield call(addStaffEffect, action.payload);
      const staffData = response.data || response; 
      yield put(addStaffSuccess(staffData));
  } catch (error) {

      const backendMessage = error.response?.data?.message || error.message || "Failed to add staff";
      yield put(addStaffFailure(backendMessage));
  }
}
function* updateStaffSaga(action) {
  try {
    const updatedStaff = yield call(
      editStaffEffect,
      action.payload.staffId,
      action.payload.staffData
    );
    yield put(updateStaffSuccess(updatedStaff));
  } catch (error) {

    const backendMessage = error.response?.data?.message || error.message || "failed";
    yield put(updateStaffFailure(backendMessage|| 'Failed to Update staff'));
  }
}

function* deleteStaffSaga(action) {
  try {
    yield call(deleteStaffEffect, action.payload.staffId);
    yield put(deleteStaffSuccess(action.payload.staffId));
  } catch (error) {
    yield put(deleteStaffFailure(error.message));
  }
}

export function* StaffSagas() {

  yield takeLatest(FETCH_LIST_STAFF_REQUEST, fetchStaffsSaga);
  yield takeLatest(FETCH_STAFF_REQUEST, fetchStaffSaga);
  yield takeLatest(ADD_STAFF_REQUEST, addStaffSaga);
  yield takeLatest(UPDATE_STAFF_REQUEST, updateStaffSaga);
  yield takeLatest(DELETE_STAFF_REQUEST, deleteStaffSaga);
  yield takeLatest(HISTORY_STAFF_REQUEST, fetchGHistoryStaffsSaga);
}